import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import { Table } from "../../components/BasicComponents";

function StudentTable({ students }) {
    return (
        <>
        <Table headers={["Nom", "Genre", "Classe"]}>
            {students.map((data) => (
                <StudentRow
                    key={data.id}
                    name={data.name}
                    genderName={data.gender_name}
                    gradeName={data.grade_name}
                />
            ))}
        </Table>
        </>
    );
}

function StudentRow({ name, genderName, gradeName }) {
    return (
        <tr>
            <td>{name}</td>
            <td>{genderName}</td>
            <td>{gradeName}</td>
        </tr>
    )
}

function Student() {
    let app = useApp();

    let [students, setStudents] = useState([]);

    useEffect(() => {
        app.sendGet("/student/listmy", data => {
            setStudents(data);
        });
    }, []);

    const randomDraw = () => {
        const studentIndex = Math.floor(Math.random() * students.length);
        alert('"' + students[studentIndex].name + '" a été choisi(e)');        
    }

    return (
        <div>
            <div className="page-title-flex">
                <h1>Mes élèves</h1>
                <div className="page-title-button-container">
                    <button onClick={randomDraw}>Tirer aléatoirement un élève</button>
                </div>
            </div>
            <StudentTable students={students} />
        </div>
    );
}

export default Student;